<template>
    <div>
        <b-card no-body>
            <b-card-header class="mb-4">
                <i class="icon-list"></i>
                <strong>{{ $t('committees.committees') }}</strong>
            </b-card-header>

            <Loader :loader="loader" />

            <b-container fluid v-show="!loader">
                <b-row>
                    <b-col>
                        <div class="mb-3 text-right">
                            <b-button
                                size="sm"
                                type="button"
                                variant="primary"
                                @click="onClickNewCommittee"
                            >
                                <i class="fas fa-users-cog fa-lg" />
                                {{ $t('committees.newCommittee') }}
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>

            <b-container v-if="committees.length" fluid>
                <b-row>
                    <b-col
                        sm="12"
                        xl="4"
                        md="6"
                        lg="6"
                        v-for="(committee, index) in committees"
                        :key="index"
                    >
                        <card-header-user
                            :id="committee.id"
                            :header="committee.title"
                            :committee="committee"
                            @deleted="removeCommitteeFromList"
                            class="header"
                        />
                    </b-col>
                </b-row>
            </b-container>

            <b-container fluid v-if="!loader && !committees.length">
                <b-row>
                    <b-col>
                        <div
                            role="alert"
                            aria-live="polite"
                            aria-atomic="true"
                            class="alert alert-info"
                        >
                            {{ $t('committees.noCommittee') }}
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-card>
    </div>
</template>

<script>
import CardHeaderUser from './components/CardHeaderUser'
import api from '@/services/api'
import Loader from '@/views/components/loader'

export default {
    name: 'CommitteesList',
    components: {
        CardHeaderUser,
        Loader,
    },
    data() {
        return {
            loader: true,
            title: '',
            users: [],
            committees: [],
        }
    },
    created() {
        api.get('admin/committees', {
            params: {
                with: 'evaluators',
            },
        })
            .then(resp => (this.committees = resp.data.data))
            .finally(() => {
                this.loader = false
            })
    },
    methods: {
        onClickNewCommittee() {
            this.$router.push({ path: 'new' })
        },
        removeCommitteeFromList(id) {
            this.committees = this.committees.filter(
                committee => committee.id != id
            )
        },
    },
}
</script>

<style>
.header {
    height: 600px;
}
</style>
